module.exports = __webpack_public_path__ + "static/media/impossible.f347a7a6.png";